import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './FormNodes.form';
import { NodesAPI } from '../../../../api';
import { useAuth } from '../../../../hooks';
import './FormNodes.css';
import { date } from 'yup';

const nodesController = new NodesAPI();

export function FormNodes(props) {
  const { close, onReload, node } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(node),
    validationSchema: validationSchema(node),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if(node) {
          console.log('UpdateForm:', formValue);
          await nodesController.updateNode(accessToken ,node._id, formValue)
          onReload();
          close();
        } else {
          console.log('CreateForm:', formValue);
          await nodesController.createNode(accessToken, formValue);
          onReload();
          close();
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Form className='form-nodes' onSubmit={formik.handleSubmit}>

      <Form.Input
        name='entity'
        type='text'
        label='Entity'
        onChange={formik.handleChange}
        value={formik.values.entity}
        error={formik.errors.entity}
      />

      <Form.Select
        name='networkId'
        label='Network ID'
        options={networkId}
        placeholder='Select'
        onChange={(_, data) => formik.setFieldValue("networkId", data.value)}
        value={formik.values.networkId}
        error={formik.errors.networkId}
      />
      
      <Form.Select
        name='networkName'
        label='Network Name'
        options={networkName}
        placeholder='Select'
        onChange={(_, data) => formik.setFieldValue("networkName", data.value)}
        value={formik.values.networkName}
        error={formik.errors.networkName}
      />

      <Form.Select
        name='type'
        label='Type Node'
        options={type}
        placeholder='Select'
        onChange={(_, data) => formik.setFieldValue("type", data.value)}
        value={formik.values.type}
        error={formik.errors.type}
      />

      <Form.Select
        name='membership'
        label='Membership'
        options={membership}
        placeholder='Select'
        onChange={(_, data) => formik.setFieldValue("membership", data.value)}
        value={formik.values.membership}
        error={formik.errors.membership}
      />
      
      <Form.Group className='groupTechContact'>
        <Form.Input
          name='nameTechnicalContact'
          width={5}
          type='text'
          label='Name Technical Contact'
          onChange={formik.handleChange}
          value={formik.values.nameTechnicalContact}
          error={formik.errors.nameTechnicalContact}
        />

        <Form.Input
          name='emailTechnicalContact'
          width={5}
          type='email'
          label='Email Technical Contact'
          onChange={formik.handleChange}
          value={formik.values.emailTechnicalContact}
          error={formik.errors.emailTechnicalContact}
        />

        <Form.Input
          name='phoneTechnicalContact'
          width={5}
          type='text'
          label='Phone Technical Contact'
          onChange={formik.handleChange}
          value={formik.values.phoneTechnicalContact}
          error={formik.errors.phoneTechnicalContact}
        />
      </Form.Group>

      <Form.Group className='groupBussContact'>
        <Form.Input
          name='nameBussinesContact'
          width={5}
          type='text'
          label='Name Bussines Contact'
          onChange={formik.handleChange}
          value={formik.values.nameBussinesContact}
          error={formik.errors.nameTechnicalContact}
        />

        <Form.Input
          name='emailBussinesContact'
          width={5}
          type='email'
          label='Email Bussines Contact'
          onChange={formik.handleChange}
          value={formik.values.emailBussinesContact}
          error={formik.errors.emailBussinesContact}
        />

        <Form.Input
          name='phoneBussinesContact'
          width={5}
          type='text'
          label='Phone Bussines Contact'
          onChange={formik.handleChange}
          value={formik.values.phoneBussinesContact}
          error={formik.errors.phoneBussinesContact}
        />
      </Form.Group>

      <Form.Field className='nodeInfoFieldInputs'>
        <Form.Input
          className='nodeInfoFieldInputs__enode'
          type='text' 
          name='enode' 
          label='ENODE'
          onChange={formik.handleChange}
          value={formik.values.enode}
          error={formik.errors.enode}
        />

        <Form.Input
          className='nodeInfoFieldInputs__addressNode'
          type='text' 
          name='ipAddress' 
          label='IP ADDRESS NODE'
          onChange={formik.handleChange}
          value={formik.values.ipAddress}
          error={formik.errors.ipAddress}
        />
      </Form.Field>

      <Form.Input
        name='coinbase'
        type='text'
        label='Coinbase'
        onChange={formik.handleChange}
        value={formik.values.coinbase}
        error={formik.errors.coinbase}
      />

      <Form.Input
        name='portp2p'
        type='text'
        label='Port'
        onChange={formik.handleChange}
        value={formik.values.portp2p}
        error={formik.errors.portp2p}
      />

      <Form.Input
        name='nodeNameEthstats'
        type='text'
        label='Node Name'
        onChange={formik.handleChange}
        value={formik.values.nodeNameEthstats}
        error={formik.errors.nodeNameEthstats}
      />
    <Form.Input
        name='dateSignature'
        type='text'
        label='Date Signature'
        onChange={formik.handleChange}
        value={formik.values.dateSignature}
        error={formik.errors.dateSignature}
      />



      {/* <Form.Input
        name='datePermissioning'
        type='datetime-local'
        label='Date Permissioning'
        onChange={(_, data) => {
          const date = new Date(data.value).toISOString();
          formik.setFieldValue('datePermissioning', date)
        }}
        value={formik.values.datePermissioning}
        error={formik.errors.datePermissioning}
      /> */}

      <Form.Group>
        <Form.Button className='btn-cr-up-node' type='submit' primary loading={formik.isSubmitting}>
          {node ? "Update Node" : "Create Node"}
        </Form.Button>
        <Form.Button className='btn-cncl-node' type='button' secondary onClick={close}>
          {"Cancel"}
        </Form.Button>
      </Form.Group>

    </Form>
  )
}

// values in select NETWORK ID
const networkId = [
  {
    key: 'netID01',
    text: '648529',
    value: '648529'
  },
  {
    key: 'netID02',
    text: '648629',
    value: '648629'
  },
  {
    key: 'netID03',
    text: '648530',
    value: '648530'
  },
  {
    key: 'netID04',
    text: '648540',
    value: '648540'
  },
  {
    key: 'netID05',
    text: '648541',
    value: '648541'
  }
];

const networkName = [
  {
    key: 'netName01',
    text: 'Pro-Testnet',
    value: 'Pro-Testnet'
  },
  {
    key: 'netName02',
    text: 'Pro-Testnet RBB',
    value: 'Pro-Testnet RBB'
  },
  {
    key: 'netName03',
    text: 'Mainnet',
    value: 'Mainnet'
  },
  {
    key: 'netName04',
    text: 'Open-Protest',
    value: 'Open-Protest'
  },
];

const type = [
  {
    key: 'type01',
    text: 'Writer',
    value: 'Writer'
  },
  {
    key: 'type02',
    text: 'Validator',
    value: 'Validator'
  },
  {
    key: 'type03',
    text: 'Bootnode',
    value: 'Bootnode'
  }
]

const membership = [
  {
    key: 'membership01',
    text: 'Basic',
    value: 'Basic'
  },
  {
    key: 'membership02',
    text: 'Standard',
    value: 'Standard'
  },
  {
    key: 'membership03',
    text: 'Premium',
    value: 'Premium'
  }
]